// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotSection\ApiPilotSection.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Pilot, PilotData, PilotOptions } from 'data/models/Pilot';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';

// PilotSectionData is the class that PilotSection serializes to/from
export interface PilotSectionData {
    Id : number;
    Url : string | null;
	
    PilotAgency : PilotAgencyData | null;
    PilotAgencyId : number;
    Pilots : PilotData[] | null;
	
    Name : string;
    Order : number;
}

// PilotSectionOptions is the class which may be passed to the PilotSection constructor to define optional initial data values
export interface PilotSectionOptions {
    Id : number;
    Url? : string | null;
	
    PilotAgency? : PilotAgencyOptions | null;
    PilotAgencyId? : number;
    Pilots? : PilotOptions[] | null;
	
    Name? : string;
    Order? : number;
}

export class PilotSection {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public PilotAgency : DataSignal<PilotAgency | null>;
    public PilotAgencyId : DataSignal<number>;
    public Pilots : SDataArray<Pilot>;
	
    public Name : DataSignal<string>;
    public Order : DataSignal<number>;

    constructor();
    constructor(data : PilotSectionOptions);
    constructor(data: PilotSectionOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.PilotAgency = S.value<PilotAgency | null>(null);
        this.PilotAgencyId = jsonableObservable(S.value<number>(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.Pilots = SArray<Pilot>([]);
	    
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
        this.Order = jsonableObservable(S.value<number>(data && data.Order !== undefined ? data.Order : 0));
    }

    static key(obj : PilotSection) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotSectionOptions) {
        return obj.Id;
    }

    static update(obj : PilotSection, data : PilotSectionOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.PilotAgencyId !== undefined) obj.PilotAgencyId(data.PilotAgencyId);
	        
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.Order !== undefined) obj.Order(data.Order);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotSection.ts